import { createContext, useContext, useEffect, useState, React } from 'react'
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword
} from 'firebase/auth'
import { auth, db } from '@/firebase'
import { doc, getDoc } from 'firebase/firestore'

export const authContext = createContext()

// es un hook personalizado useAuth
export const useAuth = () => {
  const context = useContext(authContext)
  if (!context) throw new Error('There is no Auth provider')
  return context
}

export function AuthProvider ({ children }) {
  const [user, setUser] = useState(null) // for AuthState change
  const [userData, setUserData] = useState({})
  const [loading, setLoading] = useState(true)
  const login = async ({ email, password }) => {
    const res = await fetch(process.env.SV_URI + '/api/v1/user/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    })
    const token = await res.json()
    window.localStorage.setItem('authToken', token.result)
    const user = await signInWithEmailAndPassword(auth, email, password)
    window.localStorage.setItem('idDadMaster', JSON.stringify({
      idDadMaster: user.user.uid
    }))
    return user
  }
  const fetchUserData = async (currentUser) => {
    const docRef = doc(db, 'UsersAll', currentUser.uid)
    const getUser = await getDoc(docRef)
    if (getUser.exists()) {
      setUserData(getUser.data())
    }
  }
  const logout = () => signOut(auth)
  const sendResetPassword = async (email) => await sendPasswordResetEmail(auth, email)
  const signup = (email, password) => createUserWithEmailAndPassword(auth, email, password)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser)
      setLoading(false)
      if (currentUser) {
        fetchUserData(currentUser)
      }
    })
    return () => unsubscribe()
  }, [])

  return (
    <authContext.Provider value={{ login, user, userData, logout, loading, sendResetPassword, signup }}>
      {children}
    </authContext.Provider>
  )
}
